<template>
  <div class="customer-form-container">
    <div class="page-header">
      <h2>{{ isEdit ? '编辑客户' : '新增客户' }}</h2>
    </div>
    
    <el-card>
      <customer-form :customer-id="customerId" />
    </el-card>
  </div>
</template>

<script>
import CustomerForm from '../components/CustomerForm'

export default {
  name: 'CustomerFormPage',
  components: {
    CustomerForm
  },
  computed: {
    customerId() {
      // 如果是编辑模式，返回路由参数中的客户ID
      return this.$route.params.id ? parseInt(this.$route.params.id) : null
    },
    isEdit() {
      // 判断是否为编辑模式
      return !!this.customerId
    }
  }
}
</script>

<style scoped>
.customer-form-container {
  width: 100%;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #333;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page-header {
    padding: 0 10px;
  }
  
  .page-header h2 {
    font-size: 18px;
  }
}
</style>